<template>
	<sa-page-layout :btnRefreshVisible="true" :showModalLoading="showModalLoading" :btnRouterBackVisible="true">
		<template slot="toolbar" v-if="nascondiCampo">
			<b-button class="my-2 my-sm-0" variant="outline-purple btn-toolbar sa-margin-left float-sm-left" @click="onClickCambiaStatoLetto"> <i class="fas fa-exchange-alt"></i>Cambia Stato Letto </b-button>
		</template>
		<template slot="table-filter">
			<rsa-configurazione-posti-letto-letti-view-component ref="cmpRsaConfigurazionePostiLettoLettiView" :jsonDataAccettazione="jsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" @nascondiCampo="onNascondiCampo" />
		</template>
		<template slot="table-body">
			<rsa-gestione-camere-storico-list-component ref="cmpGestioneCamereStoricoList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
		</template>
		<template slot="table-footer">
			<state-change-modal-component ref="cmpStateChangeModalComponent" @cambioStatoSuccess="onCambioStatoSuccess"></state-change-modal-component>
		</template>
	</sa-page-layout>
</template>

<script>
import StateChangeModalComponent from "../../../utility/components/StateChangeModalComponent.vue";
import RsaConfigurazionePostiLettoLettiViewComponent from "../../rsaconfigurazione/components/RsaConfigurazionePostiLettoLettiViewComponent.vue";
import SaPageLayout from "../../../../template/layout/components/SaPageLayout.vue";
// import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaGestioneCamereStoricoListComponent from "../components/RsaGestioneCamereStoricoListComponent.vue";

export default {
	mixins: [UtilityMixin],
	components: { RsaConfigurazionePostiLettoLettiViewComponent, SaPageLayout, RsaGestioneCamereStoricoListComponent, StateChangeModalComponent },
	data() {
		return {
			showModalLoading: false,
			idAccettazione: null,
			idLetto: null,
			numeroCartella: null,
			nascondiCampo: null,
			pathResourceAccettazione: "/accettazioni",
			pathResourceStato: "/rsapostilettolettostati",
			pathResourceAggiornaStato: "/rsapostilettolettostatistorico",
			jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {} },
		};
	},
	mounted() {
		let me = this;
		me.id = this.$route.params.id;
		me.loadData();
	},
	methods: {
		loadData() {
			let me = this;
			me.$refs.cmpRsaConfigurazionePostiLettoLettiView.loadData(me.id);
			me.$refs.cmpGestioneCamereStoricoList.loadDataLettiStorico(me.id);
		},
		onAfterLoadData() {
			let me = this;
			me.showModalLoading = false;
			// console.log("jsonDataRicevuto: ", me.jsonData);
		},
		onBeforeLoadData() {
			let me = this;
			me.showModalLoading = true;
		},
		onClickCambiaStatoLetto() {
			let me = this;
			me.$refs.cmpStateChangeModalComponent.show({ idLetto: me.id }, null, me.pathResourceAggiornaStato, [{ stato: "DISPONIBILE" }, { stato: "SOSPESO" }, { stato: "LIBERO" }]);
		},
		onCambioStatoSuccess() {
			let me = this;
			me.$refs.cmpGestioneCamereStoricoList.loadDataLettiStorico(me.id);
		},
		onNascondiCampo(input) {
			let me = this;
			me.nascondiCampo = input;
		},
	},
};
</script>

<style></style>
